const MeetingTimes = {
  days: [
    {
      id: 0,
      value: "Weekdays",
      short: "Weekdays",
      isChecked: false,
    },
    {
      id: 1,
      value: "Mondays",
      short: "Mon",
      isChecked: false,
    },
    {
      id: 2,
      value: "Tuesdays",
      short: "Tue",
      isChecked: false,
    },
    {
      id: 3,
      value: "Wednesdays",
      short: "Wed",
      isChecked: false,
    },
    {
      id: 4,
      value: "Thursdays",
      short: "Thu",
      isChecked: false,
    },
    {
      id: 5,
      value: "Fridays",
      short: "Fri",
      isChecked: false,
    },
  ],

  hours: [
    {
      id: 0,
      value: "7am-8am",
      isChecked: false,
    },
    {
      id: 1,
      value: "11am-12pm",
      isChecked: false,
    },
    {
      id: 2,
      value: "12pm-1pm",
      isChecked: false,
    },
    {
      id: 3,
      value: "4pm-5pm",
      isChecked: false,
    },
    {
      id: 4,
      value: "5pm-6pm",
      isChecked: false,
    },
  ],
};

export default MeetingTimes;
